// SearchOrganizationsPaged.js
import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import { CircularProgress, Paper } from '@mui/material';

import { LoginContext } from '../../../../App'; // Import the LoginContext
import { fetchOrganizationsWithMemberAndLicenseCountAndActiveStatusData } from '../../../../services/b2b-users-apiService'
import OrganizationsTable from './OrganizationsTable';
import { generateClassName, generateTextField, handleObjectFieldChange } from '../../../b2b-common/helpers';
import { Search } from '@mui/icons-material';

import './SearchOrganizationsPaged.css';
import B2BFormContainer from '../../../b2b-common/B2BFormContainer';

const SearchOrganizationsPaged = ({ uuidsBlacklist = null, forceRefresh = false, onSelectedOrganization, className, elementsPerPage = 10 }) => {
    const [pagedOrganizationsData, setPagedOrganizationsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [page, setPage] = useState(1);
    const [refresh, setRefresh] = useState(true);
    const [pagesCount, setPagesCount] = useState(1);
    const [searchFields, setSearchFields] = useState({
        organizationName: '',
    });

    const { loginData } = useContext(LoginContext);

    const fetchOrganizationsData = useCallback(async (page) => {
        try {
            if (loginData) {
                setLoading(true);
                const { accessToken } = loginData;
                const data = await fetchOrganizationsWithMemberAndLicenseCountAndActiveStatusData(page - 1, elementsPerPage, searchFields, accessToken, uuidsBlacklist);
                setPagedOrganizationsData(data);
                setPagesCount(data.totalPages);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    }, [loginData, setLoading, setPagedOrganizationsData, setPagesCount, setError, searchFields]);

    useEffect(() => {
        if (forceRefresh) {
            setRefresh(true);
        }
    }, [forceRefresh]);

    useEffect(() => {
        //console.log("SearchOrganizationsPaged - useEffect - page+refresh: ", page, refresh);
        if ((refresh) && (page !== 0)) {
            fetchOrganizationsData(page);
            setRefresh(false);
        }
    }, [page, elementsPerPage, refresh, fetchOrganizationsData]);

    const handleSelectOrganization = (organization) => {
        onSelectedOrganization(organization);
    };

    const handlePageChange = (event, value) => {
        setRefresh(true);
        setPage(value);
    };

    const buttonsConfig = [
        {
            label: 'Search',
            disabledText: 'Search',
            onClick: () => {
                fetchOrganizationsData(1);
                setPage(1);
            },
            isLoading: loading,
            color: 'secondary',
            variant: 'contained',
            key: '1',
            icon: <Search />,
        },
    ];

    return (

        <div className={generateClassName("search-orgs", "", className)}>

            <B2BFormContainer title="Search form" className="organization-search-form" orientation="horizontal" showDivider={false} buttonsConfig={buttonsConfig}>
                {generateTextField("Name", searchFields.organizationName, generateClassName("organization-search-form", "-field"), false, (e) => handleObjectFieldChange('organizationName', e.target.value, setSearchFields), { required: false })}
            </B2BFormContainer>

            {loading && <CircularProgress className="centered-spinner" />}
            {error && <p>Error: {error}</p>}
            {
                !loading && pagedOrganizationsData && (
                    <div className={generateClassName("search-orgs", "-table-container", className)}>
                        <OrganizationsTable
                            organizations={pagedOrganizationsData}
                            onSelectOrganization={handleSelectOrganization}
                            pagesCount={pagesCount}
                            currentPage={page}
                            onPageChange={handlePageChange}
                            className={'organizations-table'}
                        />
                    </div>
                )
            }
        </div>

    );
};

export default SearchOrganizationsPaged;